<template>
<div>

    <div style="margin-top: 150px;width:490px;margin:0 auto;"> 
        
              <h1 class="display-3">SORRY PAGE WAS NOT FOUND</h1>
   
       </div>
</div>
 
</template>

<script>
import localStorageSvc from "@/services/localStorage";
export default {
    created(){
        localStorageSvc.removeUser();
    }
}
</script>
 